import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle } from 'recompose'
import { injectIntl } from 'react-intl'

import { getFullExternalPartnerInfo } from '../selectors/externalpartners.js'
import { getExternalPartner } from '../store/reducers/externalpartners/list.js'
import { getActions1, clear } from '../store/reducers/externalpartners/externalpartner.js'

import numeral from 'numeral'
import Link from './../components/Link'
import PdfLogo from '../components/Icons/Pdf'

const ExternalPartnerPage = ({ info, actions = [], intl }) => {
  if (info) return (
  <div className='ExternalPartners'>
    <div className='Container Container_light'>
	
      <div className="ExternalPartner__row">
        <div className="ExternalPartner__col">
          <div className='ExternalPartner__head'>{info.title}</div>
          <img className='ExternalPartner__logo' src={info.image} />
          <a href={info.site} target='_blank' className='Link Link_orange Action__link'>{info.site}</a>
          <div className="ExternalPartner__row-description">
            <span className="ExternalPartner__row-orange">Описание:&nbsp;</span>
            <pre>{info.description}</pre>
          </div>
        </div>
        <div className="Action__col-right">
          <div className='Action__donations'>Собрано {(numeral(info.externalPaymentsStats.sum).format('0,0') == 0) 
			  ? ((info.title === 'Bionova') 
			    ? '773 265₽' 
				: ((info.title === 'Boardriders') 
				  ? '100 000₽' 
				  : 'coming soon'))  
			  : (numeral(info.externalPaymentsStats.sum).format('0,0') + ' ₽')}
		  </div>
          <div className='Action__donations-small'>
		    {(numeral(info.externalPaymentsStats.personsCount).format('0,0') == 0 ) 
			  ? ((info.title === 'Bionova') 
			    ? '' 
				: ((info.title === 'Boardriders') 
			      ? '' 
				  : 'coming soon')) 
			  : (info.externalPaymentsStats.personsCount + ' человек участвовали в акции')} 
		  </div>
        </div>
      </div>

      <div className='big'>Проведенные акции</div>
          {actions.map(el => {
			//при наличие alias будет включен в ссылку на лот, если нет остается id
			let alias = el._id
			if(el.alias)
            {
              alias = el.alias
            }
            return (
            <div className='ActionsTable'>
			  <Link to={'/actions/' + alias} key={el._id} >
			    <div className='ActionsTable__inner'>
          {el.image && <img className='ActionsTable__img' src={el.image} alt={el.title} />}
			  	<span className='ActionsTable__name SubHead'>{el.title}</span>
			  	<span className='ActionsTable__price Small'>Собрали: {el.externalPaymentsStats ? 
			  	((numeral(el.externalPaymentsStats.sum).format('0,0') == 0) ? 'coming soon' : (numeral(el.externalPaymentsStats.sum).format('0,0') + ' ₽'))
			  	 : "coming soon"}</span>
			  	<span className='ActionsTable__price2 Small'>Охват: {el.externalPaymentsStats ? 
			  	((numeral(el.externalPaymentsStats.personsCount).format('0,0') == 0) ? 'coming soon' : (el.externalPaymentsStats.personsCount + ' людей'))
			  	: "coming soon"} </span>
			  	<div className='ActionsTable__gradient' />
			    </div>
			  </Link>
        	  {/*<div className="ExternalPartner__list-item">
                <button type="button" className="ExternalPartner__pdf-button"><PdfLogo /></button>
              </div>*/}
           </div>
          )})}
      </div>
  </div>	
  ); else return null
}

const mapStateToProps = () => {
  const getInfo = getFullExternalPartnerInfo()
  return (state, props) => ({
    info: getInfo(state, props),
    ...state.externalpartners.externalpartner
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({ 
  getExternalPartner, 
  getActions1,
  clear 
}, dispatch)

const mergeProps = (state, dispatch, props) => {
  const getDetails = async (id) => {
    if (!id) return
    await Promise.all([
      dispatch.getActions1(id),
      //dispatch.getLots(id),
      //dispatch.getPersons(id)
    ])
  }

  const getInfo = async (id) => {
    id = id || props.id
    if (!id) return

    let code
    if (!props.info) code = await dispatch.getExternalPartner(id)
    if (props.info || code === 200) await getDetails(id)
    if (!props.info && code !== 200) props.on404()
  }

  return { ...props, ...state, getInfo }
}

export default injectIntl(compose(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  lifecycle({
    async componentWillMount() {
      await this.props.getInfo()
    },
    componentWillReceiveProps(np) {
      if (np.id !== this.props.id) this.props.getInfo(np.id)
    }
  })
)(ExternalPartnerPage))



// WEBPACK FOOTER //
// ./src/containers/ExternalPartner.jsx